import { fetchSession } from './connectorApi';
import { mapSessionError, mapSessionResponse } from './mapSessionResponse';
import { SYNC_ERROR_CODES } from './constants';
import { getSessionCache, setSessionCache } from './sessionCache';

export const refreshSessionCache = async (sessionId) => {
    if (!sessionId) {
        return { success: false, errorCode: SYNC_ERROR_CODES.SESSION_CACHE_EMPTY };
    }

    try {
        const { data } = await fetchSession(sessionId);
        const result = mapSessionResponse(data, sessionId);

        if (result.needsSageIdLogin) {
            return { needsSageIdLogin: true };
        }

        if (!result.success) {
            return {
                success: false,
                errorCode: result.errorCode ?? SYNC_ERROR_CODES.SESSION_CACHE_EMPTY,
            };
        }

        if (result.sessionCache) {
            setSessionCache(result.sessionCache);
            return { success: true, cache: result.sessionCache };
        }

        return { success: false, errorCode: SYNC_ERROR_CODES.SESSION_CACHE_EMPTY };
    } catch (error) {
        return mapSessionError(error);
    }
};

export const resolveSessionCache = async (sessionId) => {
    const cache = getSessionCache();

    if (cache?.sessionId && cache?.companies) {
        return { success: true, cache };
    }

    return refreshSessionCache(sessionId);
};
